// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__jmUgL","list":"NavBar_list__TjU6w","item":"NavBar_item__MV5cM"};